export default "__VITE_ASSET__CdlhXKgL__"